// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"0d9192dc","758":"94041706"}[chunkId] + ".chunk.js";
};